import { reduceToDigit } from './reduce.js';
/**
 * Daily personal number — combines your birth-date digits with today's
 * date digits, reduces. Same person gets a different number every day.
 *
 * `today` defaults to the current date but is parameterised so the front-
 * end can pass a timezone-aware "today in local tz" string.
 */
export function calcDailyNumber(birthDate, today = new Date()) {
    const birthSum = sumDigits(birthDate.replace(/\D/g, ''));
    const todayStr = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
    const todaySum = sumDigits(todayStr);
    return reduceToDigit(birthSum + todaySum);
}
function sumDigits(s) {
    let sum = 0;
    for (const ch of s) {
        const d = parseInt(ch, 10);
        if (!Number.isNaN(d))
            sum += d;
    }
    return sum;
}
//# sourceMappingURL=daily.js.map